'use strict';

module.exports = /* @ngInject */ function() {
	return {
		restrict: 'E',
		scope: {
		},
		templateUrl: `./${BUILD_PATH}/header-client-quotation.directive.html`,
		controller: /* @ngInject */ function ($scope) {
		}
	};
}
